import { SNACKBAR } from "../Action";

const intialState = {
  snackBarData: {
    open: false,
    message: "",
    severity: "",
    duration: 4000,
  },
};
const ShowSnackbarReducer = (state = intialState, action) => {
  switch (action.type) {
    case SNACKBAR.snackBar:
      return {
        ...state,
        snackBarData: { ...state.snackBarData, ...action.data },
      };
    default:
      return state;
  }
};
export default ShowSnackbarReducer;
